/* eslint-disable no-debugger */
import { StatefulLoader } from '@mauriceguest/guest'
import { AbstractBookingLoader } from '../../generated'

export default class BookingLoader extends AbstractBookingLoader {}

/** @constructor @extends {BookingLoader} @suppress {checkTypes} */ function _BookingLoader() {}
AbstractBookingLoader.__implement(StatefulLoader,
 _BookingLoader.prototype = /** @type {!BookingLoader} */ ({
  async CreateBooking({
   tariff,
   startDate,
   endDate,
  }) {
   const {
    props: { HOST, bike_id },
    asIStateful: { setState },
    asIStatefulLoader: { fetchJSON },
   } = this

   // debugger
   const body = new FormData() // can create form element???
   body.append('bike_id', `${bike_id}`)
   body.append('tariff', `${tariff}`)
   body.append('startDate', `${startDate}`)
   body.append('endDate', `${endDate}`)

   const booking_id = await fetchJSON(`${HOST}/api/booking`, {
    method: 'POST',
    credentials: 'include',
    body,
   })
   setState({ booking_id })

   return booking_id
  },
 }),
)